interface Props {
  title: string;
  rows?: number;
}

export function CardSkeleton({ title, rows = 3 }: Props): JSX.Element {
  return (
    <section className="card" aria-busy="true">
      <h2 className="card-title">{title}</h2>
      <div className="space-y-2">
        {Array.from({ length: rows }).map((_, i) => (
          <div key={i} className="skeleton h-5 w-full" />
        ))}
      </div>
    </section>
  );
}

export function CardError({
  title,
  message,
  onRetry,
}: {
  title: string;
  message: string;
  onRetry?: () => void;
}): JSX.Element {
  return (
    <section className="card ring-severity-high/40">
      <h2 className="card-title">{title}</h2>
      <p className="text-sm text-severity-high">{message}</p>
      {onRetry && (
        <button type="button" className="btn-primary text-xs mt-3" onClick={onRetry}>
          Retry
        </button>
      )}
    </section>
  );
}
